import { PATH_INSPECTOR_DETAIL_TAB } from 'components/DeviceView/deviceViewConstants';
import type { DeviceViewEntity } from 'components/DeviceView/deviceViewTypes';

export const canSelectDeviceViewPathLookupTable = (
  deviceViewEntity?: DeviceViewEntity,
): boolean =>
  deviceViewEntity !== undefined &&
  deviceViewEntity.deviceViewElement === 'node' &&
  deviceViewEntity.table !== PATH_INSPECTOR_DETAIL_TAB;
